import '../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import LuckyIcon from '../../appearance/LuckyIcon';
import * as COLOR from '../../appearance/Colors';

import './AuthLayout.scss';

const heroBg = `${process.env.PUBLIC_URL || ''}/landing/hero-bg.generated.webp`;

const AuthLayout = ({ children }) => {
    const {t: lnT} = useTranslation();

    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div className="auth-page">
            <div className="auth-page-bg" aria-hidden="true">
                <img src={heroBg} alt="" loading="eager" decoding="async" />
                <div className="auth-page-bg-overlay" />
            </div>

            <div className="auth-content">
                {isMobile ? (
                    <div className="auth-mobile-banner" onClick={() => history.push('/mobile')}>
                        <span className="auth-mobile-banner-icon">📲</span>
                        <div className="auth-mobile-banner-body">
                            <div className="auth-mobile-banner-text">{lnT('auth:luckynoteWorksBetterAsAStandaloneApp')}</div>
                            <div className="auth-mobile-banner-cta">{lnT('auth:downloadApp')}</div>
                        </div>
                    </div>
                ) : null}

                <div className="auth-logo" onClick={() => history.push('/home')}>
                    <LuckyIcon />
                </div>

                <div className="auth-card">{children}</div>
            </div>
        </div>
    );
};

export default AuthLayout;
